<script lang="ts">
  export let horizontal: boolean = false;
  export let vertical: boolean = false;
  export let center: boolean = false;
  export let alignItems: string = "flex-start";
  export let justifyContent: string = "flex-start";
  export let alignSelf: string = "auto";
  export let overflow: string | null = null;
  export let spacing: string = "";
  export let padding: string | null = null;
  export let backgroundColor: string | null = null;
  export let borderBottom: boolean = false;
  export let borderRight: boolean = false;
  export let childrenFlex: boolean = false;
</script>

<div
  class:horizontal
  class:vertical
  class:center
  class:borderBottom
  class:borderRight
  class:xs={spacing === "x-small"}
  class:ss={spacing === "small"}
  class:sm={spacing === "medium"}
  class:sl={spacing === "large"}
  class:childrenFlex
  style="align-items: {alignItems}; justify-content: {justifyContent}; padding: {padding}; background-color: {backgroundColor}; align-self: {alignSelf}; overflow: {overflow};"
>
  <slot />
</div>

<style>
  /* spread all the available space between children evenly if childrenFlex is passed */
  div.childrenFlex > :global(*) {
    flex: 1;
  }

  .horizontal {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-grow: 1;
  }
  .vertical {
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-grow: 1;
    flex-basis: 0;
  }
  .center {
    align-items: center;
    justify-content: center;
  }

  .borderRight {
    border-right: solid 1px var(--rk-divider-0);
  }

  .borderBottom {
    border-bottom: solid 1px var(--rk-divider-0);
  }

  .horizontal.xs > :global(*) {
    margin-right: 4px;
  }
  .horizontal.ss > :global(*) {
    margin-right: 8px;
  }
  .horizontal.sm > :global(*) {
    margin-right: 12px;
  }
  .horizontal.sl > :global(*) {
    margin-right: 18px;
  }

  .horizontal > :global(:last-child) {
    margin-right: 0;
  }

  .vertical.xs > :global(*) {
    margin-bottom: 4px;
  }

  .vertical.ss > :global(*) {
    margin-bottom: 8px;
  }
  .vertical.sm > :global(*) {
    margin-bottom: 12px;
  }
  .vertical.sl > :global(*) {
    margin-bottom: 18px;
  }

  .vertical > :global(:last-child) {
    margin-bottom: 0;
  }
</style>
